import { captureException } from '@sentry/react';

import { COOKIES_NAMES } from 'constants/cookies';
import { cookieBasketService } from 'services/cookieBasketService';
import { cookiesDataService } from 'services/cookiesDataService';
import { getBasketProductIds } from 'store/common/basket/selectors';
import { getCurrentRegionCode } from 'store/common/settings/selectors';
import { openOutOfStockPopup } from 'store/Comparison/outofstock/actions';

import { cartApi } from '../../../api';
import { SIMILR_PRODUCTS_ACTIONS } from './constants';
import { getSimilarProductsProductsSelector } from './selectors';

export const setSimilarProductsAddedDeviceId = (payload) => ({
  payload,
  type: SIMILR_PRODUCTS_ACTIONS.SET_CHOICE_RECOMMENDS_IS_CMP_DEVICE,
});

export const setSimilarProducts = (payload) => ({
  payload,
  type: SIMILR_PRODUCTS_ACTIONS.SET_SIMILR_PRODUCTS,
});

export const setSimilarProductsIsFavorite = (payload) => (dispatch) => {
  dispatch({
    payload,
    type: SIMILR_PRODUCTS_ACTIONS.SET_SIMILR_PRODUCTS_IS_FAVORITE_DEVICE,
  });
};

export const setSimilarProductsIsCmp = (payload) => ({
  payload,
  type: SIMILR_PRODUCTS_ACTIONS.SET_SIMILR_PRODUCTS_IS_CMP_DEVICE,
});

export const addSimilarProductsDeviceToBasketThunk = (device) => async (dispatch, getState) => {
  try {
    const state = getState();
    const regionPath = getCurrentRegionCode(state);
    const basketId = cookieBasketService.getBasketIdCookie();
    const { article, id, isInBasket } = device;

    if (!isInBasket) {
      if (device.isOutOfStock) {
        dispatch(openOutOfStockPopup(id, article));
        return;
      }

      const items = [
        {
          id,
          itemType: 'product',
          quantity: 1,
        },
      ];

      dispatch(setSimilarProductsAddedDeviceId(id));

      if (basketId) {
        await cartApi.basketMergeItems(basketId, items);
      } else {
        const data = await cartApi.basketCreateBasket(
          cartApi.helpers.createBasketData(items, regionPath),
        );

        cookieBasketService.setBasketIdCookie(data?.id);
      }

      dispatch(setSimilarProductsAddedDeviceId(null));
    }
    window.location.href = '/basket/';
  } catch (error) {
    captureException(error);
    dispatch(setSimilarProductsAddedDeviceId(null));
  }
};

export const setSimilarProductsWithBasketData = () => async (dispatch, getState) => {
  const state = getState();
  const deviceList = getSimilarProductsProductsSelector(state);
  const basketProductIds = getBasketProductIds(state);

  const favoriteList = cookiesDataService.getDataList(COOKIES_NAMES.FAVORITE_DEVICES);
  const favoriteListSet = new Set(favoriteList);
  const basketProductIdsSet = new Set(basketProductIds);

  const similarProducts = deviceList.map(({ id, ...rest }) => ({
    ...rest,
    id,
    isFavorite: favoriteListSet.has(id),
    isInBasket: basketProductIdsSet.has(id.toString()),
  }));

  dispatch(setSimilarProducts(similarProducts));
};
